
import BScroll from "better-scroll";
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
@Component
export default class DivScroll extends Vue {
  private scroll: objAny = {};
  @Prop({ default: "" }) private contentClass!: string;
  mounted() {
    this.$nextTick(() => {
      //$refs绑定元素

      this.scroll = new BScroll(this.$refs.wrapper, {
        //开启点击事件 默认为false
        click: true,
        mouseWheel: true,
        scrollY: true,
        momentumLimitDistance: 5,
        scrollbar: {
          fade: true,
          interactive: false // 1.8.0 新增
        },
        preventDefault: false
        // fade: false
      });
    });
  }
}
